"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStore = void 0;
const react_1 = require("react");
function useStore(store, options) {
    const [state, setState] = (0, react_1.useState)(() => {
        return {
            state: store.state,
            prevState: undefined
        };
    });
    const handleStateChange = (0, react_1.useCallback)((storeState, prevStoreState) => {
        setState({ state: storeState, prevState: prevStoreState });
    }, []);
    (0, react_1.useEffect)(() => {
        store.subscribe(handleStateChange);
        return () => {
            store.unsubscribe(handleStateChange);
            if (options && options.reset)
                store.reset();
        };
    }, []);
    return {
        state: state.state,
        setState: store.setState,
        prevState: state.prevState,
        initialState: store.initialState,
        reset: store.reset
    };
}
exports.useStore = useStore;
//# sourceMappingURL=useStore.js.map